import { render, staticRenderFns } from "./Soa.vue?vue&type=template&id=26076295&lang=pug"
import script from "./Soa.vue?vue&type=script&lang=js"
export * from "./Soa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FormESoa: require('/home/docker/code/frontend/components/form/ESoa.vue').default})
